import * as ko from "knockout";
import Bao from "./../services/bao-service";
import './../components/table-control/table-control'
import GenericListSearchTab from "./generic-list-search-tab";

abstract class GenericListSearchTabDxGrid extends GenericListSearchTab {

    //#region Properties

    /**
     * TableControlKey to identify the table control for saving the latest state.
     */
    protected TableControlKey: KnockoutObservable<string> = 
        ko.computed(() => this.ControllerUrl);

    /**
     * TableControlLoadKey to uniquely identify the table control which should reload it's data.
     */
    protected TableControlLoadKey: KnockoutObservable<string> = 
        ko.computed(() => this.TableControlKey() + "_" + this.Parent.PrimaryKeyValue());

    /**
     * Available Columns which are displayed in the DataGrid.
     */
    AvailableColumns: KnockoutObservableArray<any> = ko.observableArray([]);  

    //#endregion

    //#region Public Methods

    /**
     * Set DataGrid Columns
     */
    abstract GetAvailableColumns(): any[];

    /**
     * Init method
     * */
    init() {
        return super.init().then(() => {
            this.AvailableColumns(this.GetAvailableColumns());
        });
    } 

    /**
    * Overriden Get method to handle virtual elements on dxGrid list
    * @returns JQueryPromise
    */
    Get(resetIndex?: boolean): JQueryPromise<void> {
        let def = $.Deferred<void>();
        Bao.raiseEvent("table-control:load", ko.unwrap(this.TableControlLoadKey));
        return def.resolve().promise();
    }

    /**
     * Method binded to dxGrid table. Method used to query table data.
     */
    LoadTableControlData = async (headerFilters, skipParam, takeParam, sortingParam, groupingParam) => {        
        this.TabPage.IsLoading(true);

        let url = this.GetWithODataQueryUrl();
        if (headerFilters?.length > 0) {
            url += "?$filter=" + headerFilters;
            url = encodeURI(url);
        } 

        let searchResult = await Bao.post(url, JSON.stringify({
            customFilter: this.CustomFilter(),
            sorting: sortingParam,
            skip: skipParam,
            take: takeParam,
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId()
        }));
        
        this.TabPage.IsLoading(false);

        return searchResult != null ? {
            data: searchResult.Models,
            totalCount: searchResult.TotalRows
        } : null;
    }

    /**
    * Gets the EdmModel for the DataGrid (Each DataType of the WorkItemModel-Properties)
    */
    LoadModelMetadata = () => {
        return Bao.post(this.ModelMetadataUrl()).then(result => {
            return result?.EdmModel;
        });
    }
        
    //#endregion

    //#region Protected Methods

    /**
     * Url to get the EdmModel for the DataGrid.
     */
    protected ModelMetadataUrl(): string { 
        return this.ControllerUrl + "/GetModelMetadata";
    }

    /**
     * Refreshes the UrlGetWithODataQuery address
     * @returns
     */
    protected GetWithODataQueryUrl(): string {
        return this.ControllerUrl + "/GetWithODataQuery";
    }

    //#endregion
}

export default GenericListSearchTabDxGrid;